export const columns = [
  {
    title: "游戏名称",
    slot: "gameId",
    align: "center",
  },
  {
    title: "主服id",
    key: "main_serverid",
    align: "center",
  },
  /* {
    title: "主服名称",
    key: "order_num",
    align: "center",
  }, */
  {
    title: "从服id",
    key: "serverid",
    align: "center",
  },
  {
    title: "从服名称",
    key: "list_name",
    align: "center",
  },
];
